import { SDKConfiguration } from "@/inference/setup/config";
import { Memory } from "@/memory";

const BRAND_OVERRIDE = window.location.host.includes(
  "helium-link-latest-khlhrvod4",
)
  ? "campussutra.com"
  : "";

type Props = {
  sections: string[];
  products: string[];
};

export async function fetchElementTags({ products, sections }: Props) {
  const brand = BRAND_OVERRIDE || window.location.host;
  let obj = {};

  Promise.all([
    ...products.map(async (nonSplitId) => {
      const id = nonSplitId.split("/").at(-1);
      const tags = await window.helium.datastore.getTags({
        id: id.split("/").at(-1),
      });
      obj[id] = { sectionInferenceAttributes: tags };
      return tags;
    }),
    (async () => {
      const tags = await window.helium.datastore.getSectionsTags({ sections });
      obj = { ...obj, ...tags };
      return [tags];
    })().catch(console.log),
  ])
    .then((list) => {
      const subcategories = list.slice(0, 3).map((e) => e.subcategory);
      Memory.recordLandingPageTags(subcategories);
    })
    .finally(() => {
      window.helium.sectionInfo = { ...window.helium.sectionInfo, ...obj };
    });
}
